// AppFooter — thin bottom bar with legal + support links. Mounted inside
// MainLayout so it appears on every authenticated page. Also imported by
// LoginPage in an inline form.
export default function AppFooter({ onNavigate, className = '' }) {
  const openLegal = (page) => (e) => {
    e.preventDefault();
    if (typeof onNavigate === 'function') onNavigate(page);
  };
  const year = new Date().getFullYear();
  return (
    <footer
      className={`border-t border-slate-800 bg-slate-950/60 px-4 py-3 text-[12px] text-slate-500 flex flex-wrap items-center gap-x-4 gap-y-2 ${className}`}
      data-testid="app-footer"
    >
      <span>© {year} AeroGuard SMS · Pilot</span>
      <span className="text-slate-700">·</span>
      <a href="#privacy"  onClick={openLegal('privacy')}       className="hover:text-cyan-300 transition-colors" data-testid="footer-privacy-link">Privacy</a>
      <a href="#terms"    onClick={openLegal('terms')}         className="hover:text-cyan-300 transition-colors" data-testid="footer-terms-link">Terms</a>
      <a href="#dpa"      onClick={openLegal('data-processing')} className="hover:text-cyan-300 transition-colors" data-testid="footer-dpa-link">Data Processing</a>
      <span className="ml-auto text-slate-600">Need help? Use the Support button in the bottom-right.</span>
    </footer>
  );
}
